module.exports = __webpack_public_path__ + "static/perfect-your-menu-bar-84f52995c324a1c47beac2366ab9c599.png";